<template>
  <div>
    <PlannerHeader class="mb-4" @click="openPickContextMenu" trackClass="track-add-journal-entry" :class="{'animate-bounce': $route.query.journalAddEntry && !plusClicked}">timeline</PlannerHeader>

    <PickContextMenu id="main-pick-context-menu" ref="pick-menu" @click="(storyType) => addJournalEntry(storyType)"/>
    <div>
      <div v-for="(journeyItem, $index) in list" :key="$index">
        <JourneyItem :journeyItem="journeyItem" class="mb-8" @setReviewToPupup="setReviewToPupup" @addStoryCallback="(date, storyType) => addJournalEntryToDate(date, storyType)" @editStory="(story) => editStory(story)"/>
      </div>

      <infinite-loading v-if="dataPrepared" direction="bottom" @infinite="infiniteHandler">
          <div slot="no-more">

            <div slot="no-body">
              <FirstChapter />
            </div>

          </div>
          <div class="h-32" slot="spinner">
            <Loader/>
          </div>
      </infinite-loading>

      <div v-else class="h-32" >
        <Loader/>
      </div>
    </div>

    <vs-popup fullscreen title="" :active.sync="reviewPopupActive">
      <Review v-if="popupReview" :review="popupReview" @close="reviewPopupActive=false"/>
    </vs-popup>

      <StorySidebar
        :editedEntity="storyEditedEntity"
        :open="storySidebarActive"
        @close="closeSidebar"
      />

  </div>
</template>

<script>
import JourneyTimeline from './JourneyTimeline'
import FirstChapter from './FirstChapter'
import JourneyItem from './JourneyItem'
import InfiniteLoading from 'vue-infinite-loading'
import Loader from '../Generic/Loader'
import Review from '../Review/Review'
import StorySidebar from '../Stories/StorySidebar'
import * as DateHelper from '@/helpers/date'

export default {
  components: {
    JourneyTimeline,
    InfiniteLoading,
    JourneyItem,
    Loader,
    FirstChapter,
    Review,
    StorySidebar
  },
  props: {

  },
  data () {
    return {
      page: 1,
      list: [],
      dataPrepared: false,
      reviewPopupActive: false,
      popupReview: null,
      storySidebarActive: false,
      storyEditedEntity: {},
      plusClicked: false
    }
  },
  computed: {
    userRegisteredAt () {
      return DateHelper.midnight(this.$store.getters.userRegisteredAt)
    },
    isMobile () {
      // return true
      return this.$store.getters.isMobile
    },
  },
  mounted () {
    this.$store.dispatch('bindTasks').then(() => {
      this.$store.dispatch('bindRoutines').then(() => {
        this.$store.dispatch('bindGoals').then(() => {
          this.$store.dispatch('bindStories').then(() => {
            this.dataPrepared = true
          })
        })
      })

    })
  },
  methods: {
    closeSidebar () {
      this.storySidebarActive = false
    },
    openPickContextMenu () {
      this.plusClicked = true
      this.$refs['pick-menu'].open()
    },
    setReviewToPupup (review) {
      console.log('reiveeeewwwww', review)

      this.popupReview = review
      this.reviewPopupActive = true
    },
    infiniteHandler ($state) {
      setTimeout(() => {

        const dayAgo = this.page - 1
        const date = DateHelper.addDays(DateHelper.midnight(), -dayAgo)
        const journeyItem = {
          date,
          ...this.$store.getters.journeyItems(date),
        }

        // console.log('dayAgo', dayAgo)
        // console.log('date', date)
        // console.log('journeyItem', journeyItem)

        if (this.userRegisteredAt <= date) {
          this.page += 1
          this.list.push(journeyItem)
          $state.loaded()
        } else {
          $state.complete()
        }

      },
      this.page === 1 ? 0 : 250)


      // axios.get(api, {
      //   params: {
      //     page: this.page,
      //   },
      // }).then(({ data }) => {
      //   if (data.hits.length) {
      //     this.page += 1;
      //     // console.log(this.dates[this.page])
      //     // this.list.push(this.dates[this.page]);
      //     this.list.push(...data.hits);
      //     $state.loaded();
      //   } else {
      //     $state.complete();
      //   }
      // });
    },
    addJournalEntry (storyType) {
      console.log('addJournalEntry', storyType)
      this.storyEditedEntity = { storyType }
      this.storySidebarActive = true
    },
    addJournalEntryToDate (date, storyType) {
      console.log('addJournalEntryToDate', date)
      this.storyEditedEntity = { deadline: date, storyType  }
      this.storySidebarActive = true
    },
    editStory (story) {
      this.storyEditedEntity = story
      this.storySidebarActive = true
    }
  }
  //   infiniteHandler (state) {
  //     console.log('infiniteHandler', state, this.page)
  //     const hit = this.dates[this.page - 1]

  //     if (hit) {
  //       this.page += 1
  //       this.list.unshift(hit)
  //       state.loaded()
  //     } else {
  //       state.complete()
  //     }
  //   },
  // }
}
</script>
